
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ApplicationDocument } from '@/commons/types'

@Component
export default class ModalBoxIsLostStolenDestroyedContent extends Vue {
    @Prop() closeCallback!: () => void
    @Prop() applicationDocument!: ApplicationDocument

    cancel (): void {
        this.closeCallback()
    }
}
